import React, { FunctionComponent } from 'react';

type Props = {
  zipCode01: string;
  zipCode02: string;
  onChange: (section: 'company' | 'userAuth' | 'planPurchase', field: string, value: string | boolean | number) => void;
};

export const Presentation: FunctionComponent<Props> = ({
  zipCode01,
  zipCode02,
  onChange,
}) => {
  return (
    <div className="form-group column">
      <div className="col-xs-3 col-form-label management-form-section-label form-group__title">
        <label>会社郵便番号</label>
        <span className="management-form-section-label-essential col-xs-2 priority">&nbsp;必須</span>
      </div>
      <div className="col-xs-7 input hidden-xs post">
        <input
          type="text"
          id="zip_code1_input"
          className="form_zin_code first form-control"
          value={zipCode01}
          onChange={(e) => onChange('planPurchase', 'zipCode01', e.target.value)}
        />
        &nbsp;-&nbsp;
        <input
          type="text"
          id="zip_code2_input"
          className="form_zin_code second form-control"
          value={zipCode02}
          onChange={(e) => onChange('planPurchase', 'zipCode02', e.target.value)}
        />
      </div>
    </div>
  );
};
